import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { MultiSelectDropdown, DROPDOWN_TYPE } from "widgets/multiselect";
import { Checkbox } from "widgets/inputs";

import { Base } from "../base";
import { MultiSelect as MultiSelectReadOnly } from "../../renderers/multiselect";

export function MultiSelect(props) {
  const { column, value, pos, row, isCheckbox = false } = props;
  const baseRef = useRef(null);
  const selectRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value || []);
  const [dataSource, setDataSource] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(
    function updateValue() {
      setCurrentValue(value || []);
      setIsOpen(false);
      // selectRef.current && selectRef.current.blur();
      // setDataSource([]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, row, pos]
  );

  return (
    <Base
      {...props}
      ref={baseRef}
      onEditing={(e) => {}}
      type={isCheckbox ? "checkbox" : `multiselect`}
    >
      {column.readOnly && (
        <MultiSelectReadOnly column={column} value={value} wrap={true} />
      )}
      {!column.readOnly && (
        <MultiSelectDropdown
          value={currentValue}
          dataSource={dataSource}
          isOpen={isOpen}
          ref={selectRef}
          onOpen={() => {
            setIsLoading(true);
            baseRef.current.startEditing(currentValue);
            column
              .dataSource({ value: currentValue, row })
              .then((dataSource) => {
                setDataSource(dataSource);
                selectRef.current.focus();
                setIsOpen(true);
                setIsLoading(false);
              });
          }}
          onSearch={({ search }) =>
            Promise.resolve(
              dataSource.filter((item) =>
                item.toLowerCase().includes(search.toLowerCase())
              )
            )
          }
          onChange={(value) => {
            selectRef.current && selectRef.current.blur();
            setTimeout(() => {
              selectRef.current && selectRef.current.focus();
              baseRef.current.startEditing(value);
              baseRef.current.dataChanged(value);
              baseRef.current.dataCompleted();
              setDataSource([]);
            }, 100);
          }}
          type={DROPDOWN_TYPE.MINIMAL}
          checkDataSourceForValue={false}
          isLoading={isLoading}
          itemRenderer={
            isCheckbox
              ? (data) => {
                  return (
                    <span>
                      <Checkbox
                        label={data}
                        value={currentValue && currentValue.includes(data)}
                      />
                    </span>
                  );
                }
              : undefined
          }
        />
      )}
    </Base>
  );
}

MultiSelect.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  pos: PropTypes.any,
  row: PropTypes.any,
  isCheckbox: PropTypes.bool
};
